// @flow
import React from 'react'
import glamorous from 'glamorous'
import { InlineLink, Wrapper } from 'components'
import { typography, margin } from 'style'

const Title = glamorous.h1({
  ...typography.largeTitle,
  ...margin.bottom(2),
})

const Body = glamorous.p({
  ...typography.body,
})

const FourOhFour = () => (
  <Wrapper py={6} css={{ textAlign: 'center' }}>
    <Title>Oh no! This page doesn’t exist.</Title>
    <Body>
      Never fear. There’s much more to explore starting on my{' '}
      <InlineLink href="/">homepage</InlineLink>.
    </Body>
  </Wrapper>
)

export default FourOhFour



// WEBPACK FOOTER //
// ./src/pages/404.js